export default __webpack_public_path__ + "static/media/superSix.6eb169b7.png";